import { useGetWhitelistQuery } from '@/modules/whitelist';
import { useShowResponseStatus } from '@/shared';

export const useGetWhitelist = () => {
  const { data, isLoading, isError } = useGetWhitelistQuery();

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  return {
    data,
    isLoading,
  };
};
